import React, { useState, useEffect, useContext } from "react";
import Sidebar from "../sidebar";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  InputAdornment,
  TextField,
  Typography,
  IconButton,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import EastIcon from "@mui/icons-material/East";
import AddIcon from "@mui/icons-material/Add";
import { ArrowBack, ArrowForward } from "@mui/icons-material";
import { companyId } from "../../../utils/companyId";
import { api } from "../../../utils/api";
import {
  percentageError,
  twoFieldError,
} from "../../../utils/validationMessage";
import ActionButtons from "../InitialKickoff/MaterialTopics/ActionButtons";
import DeleteIcon from "@mui/icons-material/Delete";

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { ProgressContext } from "../ContextAPI";
import SkipQuestionare from "../../Common/SkipQuestionare";
import InitialQuestionareSidebar from "../../../Layout/InitialQuestionareSidebar";
import { getQuestionareSubmitted } from "../../../utils/storage";
const DevelopmentAndIncusion = () => {
  const companyDetails = getQuestionareSubmitted();

  const navigate = useNavigate();
  const { setUpdate } = useContext(ProgressContext);

  const [womenInWorkforce, setWomenInWorkforce] = useState("");
  const [womenInManagement, setWomenInManagement] = useState("");
  const [womenInBoard, setWomenInBoard] = useState("");
  const [minorityEmployees, setMinorityEmployees] = useState("");
  const [malePayGap, setMalePayGap] = useState("");
  const [femalePayGap, setFemalePayGap] = useState("");
  const [minorityPayGap, setMinorityPayGap] = useState("");
  const [majorityPayGap, setMajorityPayGap] = useState("");
  const [initiative1, setInitiative1] = useState("");
  const [effectiveness1, setEffectiveness1] = useState("");
  const [fields, setFields] = useState([{ initiative: "", effectiveness: "" }]);

  // const [initiative2, setInitiative2] = useState('');
  // const [effectiveness2, setEffectiveness2] = useState('');
  const [isUpdating, setIsUpdating] = useState(false);
  const [isExist, setIsExist] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState(null);

  // Validation states
  const [errors, setErrors] = useState({
    womenInWorkforce: "",
    womenInManagement: "",
    womenInBoard: "",
    minorityEmployees: "",
    malePayGap: "",
    femalePayGap: "",
    minorityPayGap: "",
    majorityPayGap: "",
    initiatives: "",
  });

  useEffect(() => {
    setUpdate("SOCIAL");
    if (companyId) {
      fetchData();
    }
  }, [companyId]);

  const fetchData = async () => {
    try {
      const response = await fetch(
        `${api}/social/diversity_inclusion/${companyId}`
      );
      if (response.ok) {
        const data = await response.json();

        setWomenInWorkforce(
          data.genderDiversity?.womenInWorkforce?.value ?? ""
        );
        setWomenInManagement(
          data.genderDiversity?.womenInManagement?.value ?? ""
        );

        setWomenInBoard(data.genderDiversity?.womenInBoard?.value ?? "");
        setMinorityEmployees(
          data.representationOfMinorities?.minorityEmployees?.value ?? ""
        );
        setMalePayGap(data.payEquity?.malePayGap ?? "");
        setFemalePayGap(data.payEquity?.femalePayGap ?? "");
        setMinorityPayGap(data.payEquity?.minorityPayGap ?? "");
        setMajorityPayGap(data.payEquity?.majorityPayGap ?? "");

        // Check if initiativesForDiversityAndInclusion is part of data
        setFields(
          data.initiativesForDiversityAndInclusion || [
            { initiative: "", effectiveness: "" },
          ]
        );

        setIsUpdating(true);
        setIsExist(true);
      } else {
        console.error("Failed to fetch data");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const validate = () => {
    const newErrors = {};
    let isValid = true;

    // Validate percentages
    if (
      // womenInWorkforce === "" ||
      isNaN(womenInWorkforce) ||
      womenInWorkforce < 0 ||
      womenInWorkforce > 100
    ) {
      newErrors.womenInWorkforce = percentageError;
      isValid = false;
    }
    if (
      // womenInManagement === "" ||
      isNaN(womenInManagement) ||
      womenInManagement < 0 ||
      womenInManagement > 100
    ) {
      newErrors.womenInManagement = percentageError;
      isValid = false;
    }
    if (
      // womenInBoard === "" ||
      isNaN(womenInBoard) ||
      womenInBoard < 0 ||
      womenInBoard > 100
    ) {
      newErrors.womenInBoard = percentageError;
      isValid = false;
    }
    if (
      // minorityEmployees === "" ||
      isNaN(minorityEmployees) ||
      minorityEmployees < 0 ||
      minorityEmployees > 100
    ) {
      newErrors.minorityEmployees = percentageError;
      isValid = false;
    }

    // Validate pay equity fields
    if (
      // malePayGap === "" ||
      isNaN(malePayGap) ||
      malePayGap < 0 ||
      malePayGap > 100
    ) {
      newErrors.malePayGap = percentageError;
      isValid = false;
    }
    if (
      // femalePayGap === "" ||
      isNaN(femalePayGap) ||
      femalePayGap < 0 ||
      femalePayGap > 100
    ) {
      newErrors.femalePayGap = percentageError;
      isValid = false;
    }
    if (
      // minorityPayGap === "" ||
      isNaN(minorityPayGap) ||
      minorityPayGap < 0 ||
      minorityPayGap > 100
    ) {
      newErrors.minorityPayGap = percentageError;
      isValid = false;
    }
    if (
      // majorityPayGap === "" ||
      isNaN(majorityPayGap) ||
      majorityPayGap < 0 ||
      majorityPayGap > 100
    ) {
      newErrors.majorityPayGap = percentageError;
      isValid = false;
    }

    const initiativeErrors = [];
    const effectivenessErrors = [];

    fields.forEach((field, index) => {
      if (index === 0) return; // Skip validation for index 0

      if (field.initiative.trim() === "") {
        initiativeErrors[index] = twoFieldError;
        isValid = false;
      }

      if (field.effectiveness.trim() === "") {
        effectivenessErrors[index] = twoFieldError;
        isValid = false;
      }
    });

    // Only set errors if there are any (excluding index 0)
    if (initiativeErrors.some((e, i) => i > 0 && e)) {
      newErrors.initiatives = initiativeErrors;
    }
    if (effectivenessErrors.some((e, i) => i > 0 && e)) {
      newErrors.effectiveness = effectivenessErrors;
    }

    setErrors(newErrors);
    return isValid;
  };

  const Save = async () => {
    if (!validate()) return; // Validate before saving
    const payload = {
      genderDiversity: {
        womenInWorkforce: { value: womenInWorkforce, unit: "%" },
        womenInManagement: { value: womenInManagement, unit: "%" },
        womenInBoard: { value: womenInBoard, unit: "%" },
      },
      representationOfMinorities: {
        minorityEmployees: { value: minorityEmployees, unit: "%" },
      },
      payEquity: {
        malePayGap: malePayGap,
        femalePayGap: femalePayGap,
        minorityPayGap: minorityPayGap,
        majorityPayGap: majorityPayGap,
      },
      initiativesForDiversityAndInclusion: fields,
      companyId: companyId,
    };

    const hasValidValue = (val) =>
      val !== undefined && val !== null && val !== "" && val !== "Select";

    const isValidFieldArray =
      Array.isArray(fields) &&
      fields.some(
        (field) =>
          hasValidValue(field.initiative) && hasValidValue(field.effectiveness)
      );
    console.log(isValidFieldArray, "isValidFieldArray");

    const diversity =
      hasValidValue(womenInWorkforce) &&
      hasValidValue(womenInManagement) &&
      hasValidValue(womenInBoard) &&
      hasValidValue(minorityEmployees) &&
      hasValidValue(malePayGap) &&
      hasValidValue(femalePayGap) &&
      hasValidValue(minorityPayGap) &&
      hasValidValue(majorityPayGap);
    // isValidFieldArray;
    payload.diversity = diversity;

    // Determine the request method and URL based on isExist
    const method = isExist ? "PUT" : "POST";
    const url = isExist
      ? `${api}/social/diversity_inclusion/${companyId}`
      : `${api}/social/diversity_inclusion`;

    try {
      const response = await fetch(url, {
        method: method,
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        await response.json();
        navigate(
          companyDetails?.questionareSubmitted
            ? "/preview"
            : "/social/community"
        );
      } else {
        const errorText = await response.text();
        const errorMessage = isExist
          ? "Failed to update data"
          : "Failed to save data";
        // alert(errorMessage);
        console.error(errorMessage, errorText);
      }
    } catch (error) {
      console.error("Error saving data:", error);
      const alertMessage = isExist
        ? "An error occurred while updating data"
        : "An error occurred while saving data";
      // alert(alertMessage);
    }
  };

  const Back = () => {
    navigate("/social/employee-development");
  };

  const handleAddClick = () => {
    setFields([...fields, { initiative: "", effectiveness: "" }]);
  };

  const handleFieldChange = (index, field, value) => {
    const newFields = [...fields];
    newFields[index][field] = value;
    setFields(newFields);
  };

  const handleDeleteClick = (index) => {
    setDeleteIndex(index);
    setDialogOpen(true); // Open the dialog instead of deleting immediately
  };

  const confirmDelete = () => {
    const newFields = fields.filter((_, i) => i !== deleteIndex);
    setFields(newFields);
    setDialogOpen(false);
    setDeleteIndex(null);
  };

  const cancelDelete = () => {
    setDialogOpen(false);
    setDeleteIndex(null);
  };

  return (
    <Box>
      <Dialog open={dialogOpen} onClose={cancelDelete}>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete this field?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={cancelDelete} color="primary">
            Cancel
          </Button>
          <Button onClick={confirmDelete} color="secondary">
            Confirm
          </Button>
        </DialogActions>
      </Dialog>

      <Box
        sx={{ display: "flex", backgroundColor: "#EDEDED", height: "100vh" }}
      >
        <Box
          sx={{
            width: "25vw",
            // overflowY: "auto",
          }}
        >
          <InitialQuestionareSidebar />
        </Box>
        <Box
          sx={{
            p: 2,
            mt: 3,
            width: "75vw",
            height: "100vh", // Full viewport height
            overflowY: "auto", // Allow vertical scrolling if content exceeds viewport
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "flex-start", // Adjust to start at the top of the box
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "80%",
              marginBottom: "1rem",
            }}
          >
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",
                zIndex: 1,
                padding: "10px 0px",
                borderRadius: "4px",
                alignSelf: "flex-start",
              }}
            >
              SOCIAL: DIVERSITY & INCLUSION
            </Typography>
            <SkipQuestionare />
          </div>

          <Box
            display="flex"
            flexDirection="column"
            gap={1}
            className="main"
            sx={{ marginTop: "20px", width: "80%" }}
          >
            <Typography
              variant="body1"
              className="heading"
              sx={{ fontWeight: "bold" }}
            >
              Gender Diversity
            </Typography>

            <TextField
              fullWidth
              placeholder="% of women in workforce"
              value={womenInWorkforce}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d*\.?\d*$/.test(value) && Number(value) <= 100) {
                  setWomenInWorkforce(value);
                  setErrors({ ...errors, womenInWorkforce: "" });
                }
              }}
              error={!!errors.womenInWorkforce}
              helperText={errors.womenInWorkforce}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Box
                        sx={{
                          height: "30px",
                          width: "1px",
                          bgcolor: "#6b6c6d",
                          marginRight: "8px",
                        }}
                      />
                      %
                    </Box>
                  </InputAdornment>
                ),
                className: "inputfield",
              }}
              sx={{
                mb: 2,
                width: "100%",
                "& .MuiInputBase-input": {
                  height: "47px",
                  padding: "0 14px",
                },
                "& .MuiFormHelperText-root": {
                  color: "#D34040", // Change the error message color
                  fontSize: "14px",
                  marginLeft: "0px",
                },
              }}
            />

            <TextField
              fullWidth
              placeholder="% of women in management"
              value={womenInManagement}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d*\.?\d*$/.test(value) && Number(value) <= 100) {
                  setWomenInManagement(value);
                  setErrors({ ...errors, womenInManagement: "" });
                }
              }}
              error={!!errors.womenInManagement}
              helperText={errors.womenInManagement}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Box
                        sx={{
                          height: "30px",
                          width: "1px",
                          bgcolor: "#6b6c6d",
                          marginRight: "8px",
                        }}
                      />
                      %
                    </Box>
                  </InputAdornment>
                ),
                className: "inputfield",
              }}
              sx={{
                mb: 2,
                width: "100%",
                "& .MuiInputBase-input": {
                  height: "47px",
                  padding: "0 14px",
                },
                "& .MuiFormHelperText-root": {
                  color: "#D34040",
                  fontSize: "14px",
                  marginLeft: "0px",
                },
              }}
            />

            <TextField
              fullWidth
              placeholder="% of women in board"
              value={womenInBoard}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d*\.?\d*$/.test(value) && Number(value) <= 100) {
                  setWomenInBoard(value);
                  setErrors({ ...errors, womenInBoard: "" });
                }
              }}
              error={!!errors.womenInBoard}
              helperText={errors.womenInBoard}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Box
                        sx={{
                          height: "30px",
                          width: "1px",
                          bgcolor: "#6b6c6d",
                          marginRight: "8px",
                        }}
                      />
                      %
                    </Box>
                  </InputAdornment>
                ),
                className: "inputfield",
              }}
              sx={{
                mb: 2,
                width: "100%",
                "& .MuiInputBase-input": {
                  height: "47px",
                  padding: "0 14px",
                },
                "& .MuiFormHelperText-root": {
                  color: "#D34040", // Change the error message color
                  fontSize: "14px",
                  marginLeft: "0px",
                },
              }}
            />

            <Typography
              variant="body1"
              className="heading"
              sx={{ fontWeight: "bold", marginTop: "10px" }}
            >
              Representation of Minorities
            </Typography>

            <TextField
              fullWidth
              placeholder="% of minority employees"
              value={minorityEmployees}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d*\.?\d*$/.test(value) && Number(value) <= 100) {
                  setMinorityEmployees(value);
                  setErrors({ ...errors, minorityEmployees: "" });
                }
              }}
              error={!!errors.minorityEmployees}
              helperText={errors.minorityEmployees}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Box
                        sx={{
                          height: "30px",
                          width: "1px",
                          bgcolor: "#6b6c6d",
                          marginRight: "8px",
                        }}
                      />
                      %
                    </Box>
                  </InputAdornment>
                ),
                className: "inputfield",
              }}
              sx={{
                mb: 2,
                width: "100%",
                "& .MuiInputBase-input": {
                  height: "47px",
                  padding: "0 14px",
                },
                "& .MuiFormHelperText-root": {
                  color: "#D34040", // Change the error message color
                  fontSize: "14px",
                  marginLeft: "0px",
                },
              }}
            />

            <Typography
              variant="body1"
              className="heading"
              sx={{ fontWeight: "bold", marginTop: "10px" }}
            >
              Pay Equity
            </Typography>

            <Box
              display="flex"
              gap={2}
              mb={2}
              sx={{
                width: "100%",
                "& .MuiInputBase-input": {
                  height: "47px",
                  padding: "0 14px",
                },
                "& .MuiFormHelperText-root": {
                  color: "#D34040", // Change the error message color
                  fontSize: "14px",
                  marginLeft: "0px",
                },
              }}
            >
              <TextField
                fullWidth
                placeholder="Male Pay Gap"
                value={malePayGap}
                onChange={(e) => {
                  setMalePayGap(e.target.value);
                  setErrors({ ...errors, malePayGap: "" });
                }}
                error={!!errors.malePayGap}
                helperText={errors.malePayGap}
              />
              <b style={{ marginTop: "8px" }}>:</b>

              <TextField
                fullWidth
                placeholder="Female Pay Gap"
                value={femalePayGap}
                onChange={(e) => {
                  setFemalePayGap(e.target.value);
                  setErrors({ ...errors, femalePayGap: "" });
                }}
                error={!!errors.femalePayGap}
                helperText={errors.femalePayGap}
              />
            </Box>
            <Box
              display="flex"
              gap={2}
              mb={2}
              sx={{
                width: "100%",
                "& .MuiInputBase-input": {
                  height: "47px",
                  padding: "0 14px",
                },
                "& .MuiFormHelperText-root": {
                  color: "#D34040", // Change the error message color
                  fontSize: "14px",
                  marginLeft: "0px",
                },
              }}
            >
              <TextField
                fullWidth
                placeholder="Minority Pay Gap"
                value={minorityPayGap}
                onChange={(e) => {
                  setMinorityPayGap(e.target.value);
                  setErrors({ ...errors, minorityPayGap: "" });
                }}
                error={!!errors.minorityPayGap}
                helperText={errors.minorityPayGap}
              />
              <b style={{ marginTop: "8px" }}>:</b>

              <TextField
                fullWidth
                placeholder="Majority Pay Gap"
                value={majorityPayGap}
                onChange={(e) => {
                  setMajorityPayGap(e.target.value);
                  setErrors({ ...errors, majorityPayGap: "" });
                }}
                error={!!errors.majorityPayGap}
                helperText={errors.majorityPayGap}
              />
            </Box>

            <Typography
              variant="body1"
              className="heading"
              sx={{ fontWeight: "bold", marginTop: "10px" }}
            >
              Initiatives for Diversity and Inclusion
            </Typography>

            {fields.map((field, index) => (
              <Box key={index} sx={{ width: "110%", display: "flex" }}>
                <Box
                  display="flex"
                  gap={2}
                  mb={1}
                  sx={{
                    width: "91%",
                    "& .MuiFormHelperText-root": {
                      color: "#D34040", // Change the error message color
                      fontSize: "14px",
                      marginLeft: "0px",
                    },
                  }}
                  key={index}
                >
                  <TextField
                    fullWidth
                    placeholder="Initiative"
                    value={field.initiative}
                    onChange={(e) => {
                      handleFieldChange(index, "initiative", e.target.value);
                      if (errors.initiatives) {
                        const updatedErrors = [...errors.initiatives];
                        updatedErrors[index] = "";
                        setErrors({ ...errors, initiatives: updatedErrors });
                      }
                    }}
                    error={!!errors.initiatives && errors.initiatives[index]}
                    helperText={errors.initiatives && errors.initiatives[index]}
                  />
                  <TextField
                    fullWidth
                    placeholder="Effectiveness"
                    value={field.effectiveness}
                    onChange={(e) => {
                      handleFieldChange(index, "effectiveness", e.target.value);
                      if (errors.effectiveness) {
                        const updatedErrors = [...errors.effectiveness];
                        updatedErrors[index] = "";
                        setErrors({ ...errors, effectiveness: updatedErrors });
                      }
                    }}
                    error={
                      !!errors.effectiveness && errors.effectiveness[index]
                    }
                    helperText={
                      errors.effectiveness && errors.effectiveness[index]
                    }
                  />
                  {/* <IconButton onClick={() => handleDeleteClick(index)} sx={{color:'#D34040'}}>
              <DeleteIcon />
            </IconButton> */}
                </Box>
                {index > 0 && (
                  <IconButton
                    sx={{ border: "none" }}
                    onClick={() => handleDeleteClick(index)}
                  >
                    <DeleteIcon />
                  </IconButton>
                )}
              </Box>
            ))}

            <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 3 }}>
              <Button
                variant="outlined"
                startIcon={<AddIcon />}
                onClick={handleAddClick}
                sx={{
                  alignSelf: "flex-end",
                  color: "#74757E",
                  borderColor: "#74757E",
                  display: "flex",
                  justifyContent: "flex-end",
                  "&:hover": {
                    backgroundColor: "rgba(25, 118, 210, 0.04)",
                    color: "#115293",
                    borderColor: "#115293",
                  },
                }}
                disabled={
                  fields[0]?.initiative.trim() === "" ||
                  fields[0]?.effectiveness.trim() === ""
                }
              >
                Add
              </Button>
            </Box>
          </Box>
          <div style={{ width: "80%", marginTop: "-7.5rem" }}>
            <ActionButtons
              Back={Back}
              Move={Save}
              disable={companyDetails?.questionareSubmitted}
            />
          </div>
        </Box>
      </Box>
    </Box>
  );
};

export default DevelopmentAndIncusion;
